export default __webpack_public_path__ + "static/media/infored.ee4c9dd3.svg";